import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-8 md:py-12 px-4 bg-brand-card border-y border-white/5" data-id="element-104">
      <div className="max-w-2xl mx-auto text-center" data-id="element-105">
        <div className="inline-flex items-center justify-center w-14 h-14 md:w-16 md:h-16 bg-brand-accent rounded-full mb-4 shadow-[0_0_20px_rgba(200,255,0,0.4)]" data-id="element-106">
          <ShieldCheck className="w-7 h-7 md:w-8 md:h-8 text-brand-dark" data-id="element-107" />
        </div>

        <h2 className="text-xl md:text-3xl font-black mb-4 text-brand-accent neon-glow uppercase tracking-tight" data-id="element-108">
          🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>

        <div className="text-sm md:text-base font-bold space-y-2 mb-4 text-gray-300" data-id="element-109">
          <p data-id="element-110">Abrís los 6 tomos. Revisás los 4 bonos. Los usás en tus clases.</p>
          <p className="text-gray-500" data-id="element-111">Si en 7 días no es lo que esperabas:</p>
          <p className="text-xl md:text-2xl font-black text-brand-dark bg-brand-accent inline-block px-4 py-2 rounded-lg shadow-lg uppercase my-2" data-id="element-112">
            Devolución del 100%
          </p>
          <p className="text-gray-500" data-id="element-113">
            Sin preguntas. Sin formularios. Sin drama.
          </p>
        </div>

        <p className="text-xs text-gray-500 font-medium" data-id="element-114">
          Desde México hasta Argentina. Desde Colombia hasta Chile. El mismo
          compromiso para todos.
        </p>
      </div>
    </section>;
}